import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../Config";
import moment from "moment";
import Tooltip from "../Tooltip";

const Table = ({
  apiData,
  // setViewDetail,
  // setSelectedData,
}) => {
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({ 
        item,
        collectionDate: moment(item.date).format("DD-MM-YYYY"),
        amount: getAmount(item),
        charges: getCharges(item),
        name: getName(item),
        gst: getGst(item),
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // const getName = (item) => {
  //   return (
  //     <div className="flex gap-1">
  //       <span className="text-zinc-900 text-sm font-medium">
  //         {item?.clientName || ""}
  //       </span>
  //       <span className="text-gray-400 text-sm font-medium">
  //         ({item?.noOfTransactions})
  //       </span>
  //     </div>
  //   );
  // };

  const getName = (item) => {
    const content = (
      <div className="flex gap-1">
        <span className="text-zinc-900 text-sm font-medium">
          {item?.clientName || ""}
        </span>
        <span className="text-gray-400 text-sm font-medium">
          ({item?.noOfTransactions})
        </span>
      </div>
    );

    return (
      <Tooltip
        label={
          <div className="text-xs leading-5">
            <div>Total Amount: ₹{item?.totalAmount || 0}</div>
            <div>Today Amount: ₹{item?.todayAmount || 0}</div>
            <div className="font-medium text-gray-800">
              Cash Amount: ₹{item?.nonKipinnAmount || 0}
            </div>
          </div>
        }
      >
        <div className="cursor-pointer">{content}</div>
      </Tooltip>
    );
  };

//   const getName = (item) => {
//   return (
//     <div className="flex flex-col">
//       <div className="flex gap-1">
//         <span className="text-zinc-900 text-sm font-medium">
//           {item?.clientName || ""}
//         </span>
//         <span className="text-gray-400 text-sm">
//           ({item?.noOfTransactions})
//         </span>
//       </div>

//       <div className="text-xs text-gray-500">
//         Total: ₹{item?.totalAmount || 0}
//       </div>
//       <div className="text-xs text-blue-500">
//         Today: ₹{item?.todayAmount || 0}
//       </div>
//       <div className="text-xs text-green-600 font-medium">
//         Cash: ₹{item?.nonKipinnAmount || 0}
//       </div>
//     </div>
//   );
// };
  const getAmount = (item) => {
    const current = item?.current?.amount || 0;
    const last = item?.lastMonth?.amount || 0;
    const diff = item?.difference || 0;

    const content = (
      <div className="flex gap-1">
        <span className="text-green-500 font-semibold">₹{current}</span>
        <span className="text-gray-400 text-sm font-medium">({last})</span>
      </div>
    );

    if (current || last) {
      return (
        <Tooltip
          label={
            <div className="text-xs leading-5">
              <div>Current Month: ₹{current}</div>
              <div>Last Month: ₹{last}</div>
              <div className="font-medium text-gray-800">
                Difference: ₹{diff}
              </div>
            </div>
          }
        >
          <div className="cursor-pointer">{content}</div>
        </Tooltip>
      );
    }

    return content;
  };

  const getGst = (item) => {
    return (
      <div className="flex gap-1">
        <span className="text-zinc-900 font-medium">
          ₹{item?.current?.gst || 0}
        </span>
        <span className="text-gray-400 font-medium">
          ({item?.lastMonth.gst || 0})
        </span>
      </div>
    );
  };

  const getCharges = (item) => {
    return (
      <div className="flex gap-1">
        <span className="text-zinc-900 font-medium">
          ₹{item?.current?.charges || 0}
        </span>
        <span className="text-gray-400 font-medium">
          ({item?.lastMonth?.charges || 0})
        </span>
      </div>
    );
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Name",
          accessor: "name",
        },
        {
          Header: "Amount",
          accessor: "amount",
        },
      ];
    }
    return [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Amount",
        accessor: "amount",
      },
      {
        Header: "Charges",
        accessor: "charges",
      },
      {
        Header: "GST",
        accessor: "gst",
      },
    ];
  }, [isMobileView]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination,
  );

  useEffect(() => {
    setCurrentPage(pageIndex); // Update current page on state change
  }, [pageIndex]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${
                          column.isSortedDesc ? "-rotate-90" : "rotate-90"
                        } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          hasdata={(apiData?.length > 0).toString()}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps()}
                  hasdata={(apiData?.length > 0).toString()}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Charges:</strong> {data[rowIndex].charges}
                        </li>
                        <li className="flex gap-2">
                          <strong>Gst:</strong> {data[rowIndex].gst}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-zinc-500 bg-slate-100`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-medium text-gray-500`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;

export default Table;
